import { render } from "./PopUpWithChevron.vue?vue&type=template&id=05e52f80&scoped=true&ts=true&lang=pug"
import script from "./PopUpWithChevron.vue?vue&type=script&lang=ts"
export * from "./PopUpWithChevron.vue?vue&type=script&lang=ts"

import "./PopUpWithChevron.vue?vue&type=style&index=0&id=05e52f80&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e52f80"]])

export default __exports__